export default __webpack_public_path__ + "static/media/Pixel1-5.e0c5e33f.gif";